import styled from 'styled-components';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';

const SkypassFooterNoticeContainer = styled(FlexBoxColumn)`
  background-color: ${(props) => props.theme.color.background.basic};
  align-items: flex-start;
  width: 1920px;
  height: 282px;
  padding-left: 290px;
`;

const StyledTextBox = styled(TextBox)`
  font-size: 13px;
  font-weight: 350;
`;

const StyledAtag = styled.a`
  font-size: 12px;
  font-weight: 350;
  color: inherit;
  text-decoration: none;
  line-height: inherit;
  background-color: unset;
  white-space: pre-wrap;
`;

const SkypassFooterSubNoticeContainer = styled(FlexBoxColumn)`
  align-items: flex-start;
  height: 156px;
`;

const StyledFooterNoticeAtag = styled.a`
  font-size: 16px;
  font-weight: 350;
  color: inherit;
  text-decoration: none;
  line-height: inherit;
  background-color: unset;
  white-space: pre-wrap;
`;

const StyledFooterNoticeTextBox = styled(TextBox)`
  font-size: 16px;
  font-weight: 350;
  height:26px;
`;

const TextBold = styled.span`
  font-weight: 500;
  padding-right: 10px;
`;

export { StyledTextBox, StyledAtag, SkypassFooterNoticeContainer, SkypassFooterSubNoticeContainer, StyledFooterNoticeAtag, StyledFooterNoticeTextBox, TextBold };
